<template>
  <div>
    <!-- 生成报表 -->
    <y-dialog
      :visible="exportVisible"
      title="添加备注"
      width="400px"
      :draggable="false"
      sureText="生成报表"
      :sureLoading="loading"
      @comfirm="onSubmit"
      @close="handleDialogClose"
    >
      <el-form label-width="85px" label-position="left">
        <el-form-item label="添加备注：">
          <el-input
            type="textarea"
            v-model="remark"
            maxlength="20"
            show-word-limit
            rows="3"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </y-dialog>

    <!-- 报表下载 -->
    <generate
      :control="control1"
      v-if="control1"
      @transData="transDataClose"
    ></generate>
  </div>
</template>
<script>
import generate from "./generate_report.vue";
import { post, postJson } from '@/api/axios'
export default {
  name: "add-remarks",
  components: {
    generate,
  },
  props: {
    control: {
      type: Boolean,
      default: false,
    },
    // 导出参数
    exportForm: {
      type: Object,
      default: () => ({}),
    },
    // 导出地址：传相对 /members-api 的路径，如 /expire/Scores/export
    exportUrl: {
      type: String,
      default: "",
    },
    // 导出的备注字段名
    exportKey: {
      type: String,
      default: "remark",
    },
  },
  data() {
    return {
      control1: false,
      exportVisible: false,
      remark: "",
      loading: false,
    };
  },
  mounted() {
    this.exportVisible = this.control;
  },
  methods: {
    onSubmit() {
      const params = {
        ...this.exportForm,
        [this.exportKey]: this.remark,
      };
      this.loading = true;
      postJson(`/members-api${this.exportUrl}`, params)
        .then((res) => {
          this.control1 = true;
          this.loading = false;
          this.$message.success(res.message);
        })
        .catch(() => {
          this.loading = false;
        });
    },

    transDataClose(val) {
      this.control1 = val;
      this.exportVisible = val;
      this.$emit("transData", false);
    },
    handleDialogClose() {
      this.exportVisible = false;
      this.$emit("transData", false);
    },
  },
};
</script>

<style lang="scss">
.el-message {
  z-index: 3018 !important;
}
</style>
